import { Button, Heading, Text } from "@/design-system";
import { WhatsAppLinkButton } from "./WhatsAppLinkButton";
import { PageSection } from "@/pages/landingPage/components/pageSection";

type CtaBandProps = {
  onDemoClick: () => void;
};

// Faixa escura: on-solid sobre ink-900 e ink-200 sobre ink-900 passam de 12:1.
export const CtaBand = ({ onDemoClick }: CtaBandProps) => (
  <PageSection labelledBy="cta-title">
    <div className="bg-ds-ink-900 rounded-ds-xl flex flex-col items-center gap-6 px-6 py-14 text-center sm:py-20">
      <Heading level={2} id="cta-title" className="text-ds-on-solid max-w-2xl">
        Pronto para reduzir a inadimplência da sua rede?
      </Heading>
      <Text size="lead" className="text-ds-ink-200 max-w-xl">
        Agende uma demonstração e veja a cobrança via WhatsApp da Fidexa
        funcionando com a carteira da sua rede.
      </Text>
      <div className="flex w-full flex-col justify-center gap-3 sm:w-auto sm:flex-row">
        <Button size="lg" onClick={onDemoClick}>
          Agendar demonstração
        </Button>
        <WhatsAppLinkButton location="cta_band" />
      </div>
    </div>
  </PageSection>
);
